import helpPng from "./help.png";

/** The raccoon poking out of the help panel (Figma "Mascot (poking outwards)"). */
export function HelpMascot({ className }: { className?: string }) {
  return <img className={className} src={helpPng} alt="" draggable={false} />;
}
